// Copyright (c) 2016 Deere & Company

import {
    readLaborAdditivePipsData,
    readOpenPipProducts,
    readOpenPipsData
} from './open-pips';
import {
    resetAllFacets,
    selectAllDealersOnInitialLoad,
    toggleDealerAccountFacetItems,
    toggleMetricsFacetItems,
    togglePipTypeFacetItems,
    updateDealerAccountFacetInput,
    updateDealerAccountFacetItem,
    updateMetricFacetItem,
    updatePipTypeFacetItem
} from './facets';
import {
    updateListFilterBy,
    updateListSortBy,
    updateListSortDirection
} from './search-filters';
import {exportToExcel} from './export-to-excel';
import {readLaborAdditivePipProducts} from '../../labor-additive/action-creators/labor-additive';
import {readOpenPipsSummary} from './open-pips-summary';
import sharedActionCreators from '../../shared/action-creators';
import {toggleReportsAccordion} from '../../shared/action-creators/reports-accordion';
import {updateSearchResults} from '../../pip-search/action-creators/select-search-by';

export default {
    ...sharedActionCreators,
    exportToExcel,
    readLaborAdditivePipProducts,
    readLaborAdditivePipsData,
    readOpenPipProducts,
    readOpenPipsData,
    readOpenPipsSummary,
    resetAllFacets,
    selectAllDealersOnInitialLoad,
    toggleDealerAccountFacetItems,
    toggleMetricsFacetItems,
    togglePipTypeFacetItems,
    toggleReportsAccordion,
    updateDealerAccountFacetInput,
    updateDealerAccountFacetItem,
    updateListFilterBy,
    updateListSortBy,
    updateListSortDirection,
    updateMetricFacetItem,
    updatePipTypeFacetItem,
    updateSearchResults
};



// WEBPACK FOOTER //
// ./src/pip/open-pips/action-creators/index.js